<template>
    <v-dialog
        :value="isOpen"
        scrollable
        max-width="450px"
        transition="slide-y-transition"
        eager
        :persistent="actionLoading"
        @keydown.esc="onClose"
        @click:outside="onClose"
    >
        <v-card>
            <v-card-title>
                <h1 class="text-subtitle-1">
                    <template>
                        Wybierz montaż źródłowy do skopiowania
                    </template>
                </h1>
            </v-card-title>
            <v-card-text>
                <v-row>
                    <v-col cols="12">
                        <v-select
                            v-model="selectedImpositionId"
                            :items="filteredImpositions"
                            item-value="id"
                            no-data-text="Nie znaleziono montaży"
                            outlined
                            dense
                            required
                        >
                            <template slot="selection" slot-scope="data">
                                {{ `Montaż ${data.item.ordinalNumber}` }}
                            </template>
                            <template slot="item" slot-scope="data">
                                {{ `Montaż ${data.item.ordinalNumber}` }}
                            </template>
                        </v-select>
                    </v-col>
                </v-row> 
            </v-card-text>

            <v-divider />

            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    :disabled="actionLoading"
                    data-sentry-label="Anuluj"
                    @click="onClose"
                >
                    Anuluj
                </v-btn>
                <v-spacer />
                <v-btn
                    color="success"
                    text
                    :loading="actionLoading"
                    data-sentry-label="Kopiuj"
                    @click="onSave"
                >
                    Zapisz
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'CopyImpositionParametersDialog',
    props: {
        isOpen: {
            type: Boolean
        },
        targetImpositionId: {
            type: Number,
            default: null
        },
        impositionsData: {
            type: Array,
            default: () =>[]
        },
        actionLoading: {
            type: Boolean
        }
    },
    data() {
        return {
            selectedImpositionId: null
        }
    },
    computed: {
        filteredImpositions() {
            return this.impositionsData.filter(imposition => imposition.id !== this.targetImpositionId)
        },
    },
    watch: {
        isOpen(boolean) {
            if (boolean) {
                this.setDefaultImpositionId()
            } else {
                setTimeout(() => {
                    this.selectedImpositionId = null
                }, 500)
            }
        }
    },
    methods: {
        setDefaultImpositionId() {
            this.selectedImpositionId = this.filteredImpositions.length ? this.filteredImpositions[0].id : null
        },
        onSave() {
            this.$emit('on-save', this.selectedImpositionId, this.targetImpositionId)
        },
        onClose() {
            if (!this.actionLoading) {
                this.$emit('on-close')
            }
        }
    }
}
</script>